export default __webpack_public_path__ + "static/media/11.2606f44d.webp";